import React from "react";

import { gridCommonFunction } from "./utils/gridCommonFunction";

const PivotChartPreview = ({ data }) => {
  const charts = data.config.layout.pivot_charts;

  let rowItemElements = [];
  let LayoutArray = [];

  charts.forEach((chart) => {
    rowItemElements.push(chart.element_config);
    LayoutArray.push(chart.grid);
  });

  let styleDataForGrid = gridCommonFunction.convertArrayInGridTemplateAreas(LayoutArray);

  return (
    <div style={styleDataForGrid}>
      {rowItemElements.map((colItem, colItemIndexIs) => {
        let styleObject = {
          gridArea: `zino-${colItem.i || colItem.id}`
        };

        return (
          <div key={colItem.id + colItemIndexIs} style={styleObject}>
            <div className="builder_display_item_container">
              {colItem?.presets?.map((preset) => (
                <div key={preset.id} className="builder_display_items" style={{ width: "fit-content" }}>
                  {preset.name}
                </div>
              ))}
            </div>

            <div
              style={{
                display: "flex",
                overflow: "hidden",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
              }}
            >
              <img
                src={require("../../../images/pivotChart.png")}
                alt=""
                style={{
                  width: "800px",
                  height: "400px"
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PivotChartPreview;
